import firebase from "../firebase"

// Referencia al documento contador en Firestore
const counterRef = firebase.firestore().collection("system").doc("counter")

// Función para obtener el siguiente ID
export const getNextId = async () => {
  try {
    // Usamos una transacción para garantizar la consistencia
    const result = await firebase.firestore().runTransaction(async (transaction) => {
      const counterDoc = await transaction.get(counterRef)

      if (!counterDoc.exists) {
        throw new Error("Counter document does not exist. Please initialize the system first.")
      }

      const currentCount = counterDoc.data().count + 1

      // Actualizar el contador
      transaction.set(counterRef, { count: currentCount })

      return currentCount
    })

    return result
  } catch (error) {
    console.error("Error getting next ID:", error)
    throw error
  }
}

// Función para verificar si el contador ya está inicializado
export const isCounterInitialized = async () => {
  try {
    const counterDoc = await counterRef.get()
    return counterDoc.exists
  } catch (error) {
    console.error("Error checking counter initialization:", error)
    return false
  }
}

// Función para inicializar y asignar IDs a registros existentes
// Esta función ahora solo se ejecutará si es necesario o bajo demanda
export const initializeCounterAndAssignIds = async () => {
  try {
    // Verificar si el contador ya existe
    const counterDoc = await counterRef.get()

    if (counterDoc.exists) {
      console.log("Counter already initialized with value:", counterDoc.data().count)
      return counterDoc.data().count
    }

    // Si no existe, necesitamos crear el contador e inicializar los IDs
    // Obtener todos los QR codes existentes
    const qrCodesSnapshot = await firebase.firestore().collection("qrcodes").get()
    const qrCodes = qrCodesSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }))

    console.log(`Found ${qrCodes.length} existing QR codes to assign IDs`)

    // Ordenar por fecha de creación para asignar IDs en orden cronológico
    qrCodes.sort((a, b) => {
      const aDate = a.createdAt ? a.createdAt.toDate() : new Date(0)
      const bDate = b.createdAt ? b.createdAt.toDate() : new Date(0)
      return aDate - bDate
    })

    // Asignar IDs secuenciales a cada documento
    const batch = firebase.firestore().batch()
    let maxId = 0

    for (let i = 0; i < qrCodes.length; i++) {
      const qr = qrCodes[i]
      const numericId = i + 1 // Empezamos desde 1
      maxId = numericId

      const docRef = firebase.firestore().collection("qrcodes").doc(qr.id)
      batch.update(docRef, { numericId })
    }

    // Crear el documento contador con el valor máximo
    batch.set(counterRef, { count: maxId })

    // Ejecutar el batch
    await batch.commit()
    console.log(`Successfully assigned IDs to ${qrCodes.length} QR codes. Current counter: ${maxId}`)

    return maxId
  } catch (error) {
    console.error("Error initializing counter:", error)
    throw error
  }
}
